import { mdiCompass } from '@mdi/js';
import { useLocation, useNavigate } from 'react-router';

import { ILocationFragment } from 'graphql/types';
import { TableCell, TableRowMedia } from 'common/components/Table';
import { Checkbox } from 'common/components/Checkbox';
import { Icon } from 'common/components/Icon';
import { ItemMedia } from 'common/components/ItemMedia';
import { getUrl } from 'route/utils/getUrl';

interface IProps {
    location: ILocationFragment;
    isSelected?: boolean;
    onSelect?(): void;
}

export const LocationsManagementTableRow = ({
    location,
    isSelected,
    onSelect,
}: IProps) => {
    const navigate = useNavigate();
    const routerLocation = useLocation();
    const { id, title, location: address, image } = location;

    const handleRowClick = () => {
        const searchParams = new URLSearchParams(routerLocation.search);
        const url = `${getUrl('MANAGEMENT_SETTINGS_LOCATION_EDIT', { id })}?${searchParams}`;

        navigate(url);
    };

    return (
        <TableRowMedia
            hover
            selected={isSelected}
            sx={{ cursor: 'pointer' }}
            onClick={handleRowClick}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(e) => {
                        onSelect?.();

                        e.stopPropagation();
                    }}
                />
            </TableCell>
            <TableCell sx={{ width: '1px' }}>
                <ItemMedia
                    color="primary"
                    image={image?.url || ''}
                    key={image?.id || `location-${id}-image`}
                    size="small"
                >
                    <Icon path={mdiCompass} size="2rem" sizeSm="3rem" />
                </ItemMedia>
            </TableCell>
            <TableCell>{title || '-'}</TableCell>
            <TableCell>{address || '-'}</TableCell>
        </TableRowMedia>
    );
};
